import { Dayjs } from "dayjs";

/**
 * Correction for the antD date picker, which does not return a date, but a timestamp at midnight local time.
 * For local time in timezone CET/CEST, this would be the previous day in UTC.
 */
export const fixDatePickerDate = (date: Dayjs | null | undefined): Dayjs | undefined => date?.add(date.utcOffset(), "minutes");

/** Delay before the toolbar appears after mouse enters the area, in seconds */
export const DEFAULT_TOOLBAR_MOUSE_ENTER_DELAY = 1; // seconds
